// Generated by sync-language-release.cjs.
import component_de from 'ant-design-vue/es/locale/de_DE';
import component_en from 'ant-design-vue/es/locale/en_GB';
const locales = { de: component_de, en: component_en };
export function componentLocaleFor(code) { return Object.hasOwn(locales, code) ? locales[code] : locales.de; }
